import React from "react";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";

import { CloseButton } from "components";

import AlertIcon from "static/images/alert.png";
import styles from "./serverError.module.scss";

const ServerErrorModal = ({
	traceId,
	instance,
	show,
	onHide,
	dialogAs,
	backdrop,
}) => {
	const modalState = useSelector(state => state.ui.modals)[0];

	const ErrorTraceId = () => {
		const errorId = traceId || modalState?.data?.trace_id;
		const environment = process.env.REACT_APP_ENVIRONMENT;

		if (environment === "Production") {
			return <p className={styles.errorTrace}>Error ID: {errorId}</p>;
		}

		return (
			<a
				href={instance || modalState?.data?.instance}
				target="_blank"
				rel="noreferrer"
				className={styles.supportLink}
			>
				Error ID: {errorId}
			</a>
		);
	};

	return (
		<Modal
			className={styles.modal}
			show={show}
			animation={false}
			centered
			dialogAs={dialogAs}
			backdrop={backdrop}
		>
			<Modal.Body className={styles.body}>
				<CloseButton onClick={onHide} />
				<img src={AlertIcon} alt="" className={styles.alertIcon} />
				<h1 className={styles.title}>Internal Server Error</h1>
				<p className={styles.description}>
					Sorry, we are having a server issue now and
					<br />
					are working on its resolution already
				</p>
				<a href="#?" className={styles.supportLink}>
					Still have a problem? Contact our support team
				</a>
				{ErrorTraceId()}
			</Modal.Body>
		</Modal>
	);
};

export default ServerErrorModal;
